import { Injectable } from '@angular/core';
import { config } from 'src/app/app.config';
import { ApiService } from '../api/api.service';
import { EventsService } from '../events.service';
import { DeviceDetectorService } from 'ngx-device-detector';

const OneSignal = window['OneSignal'] || [];

@Injectable({
  providedIn: 'root'
})
export class OneSignalService {

  device: any;
  oneSignalId: any;
  token: any = '';
  ONE_SIGNAL_ID = config.baseURL + 'ONE_SIGNAL_ID';

  constructor(
    private api: ApiService,
    private eventsService: EventsService,
    private deviceService: DeviceDetectorService,
  ) {
    this.token = window.localStorage.getItem(config.baseURL + '/token');
    this.oneSignalId = window.localStorage.getItem(this.ONE_SIGNAL_ID) || '';
    console.log(this.oneSignalId);
  }

  initOneSignal() {
    this.device = this.deviceService.getDeviceInfo();
    console.log('Init OneSignal');
    OneSignal.push(function() {
      OneSignal.init({
        appId: config.oneSignalID,
        autoRegister: true,
        allowLocalhostAsSecureOrigin: true,
        notifyButton: {
            enable: false,
        },
      });
    });
    this.checkIfSubscribed();
  }

  subscribe() {
    const _this = this;
    _this.getOneSignalUserID();
    OneSignal.push(() => {
        OneSignal.on('subscriptionChange', (isSubscribed) => {
            console.log('The user\'s subscription state is now:', isSubscribed);
            if (isSubscribed) {
              _this.getOneSignalUserID();
            }
        });
    });
  }

  listenForNotification() {
    console.log('Initalize Listener');
    const _this = this;
    OneSignal.push(function () {
      OneSignal.on('notificationDisplay', (event) => {
        console.log('OneSignal notification displayed:', event);
        _this.notificationCount();
      });
    });
  }

  notiClick() {
    OneSignal.push(['addListenerForNotificationOpened', function(data) {
      console.log('Received NotificationOpened:');
      console.log(data);
    }]);
  }

  getOneSignalUserID() {
    const _this = this;
    try {
      if (_this.oneSignalId) {
        this.api.registerDevice(this.token, this.oneSignalId, this.device.browser).subscribe((res: any) => {
          console.table(res);
          _this.listenForNotification();
        }, (err: any) => {
          console.table(err);
        });
      } else {
        OneSignal.push(function () {
          console.log('Befor get userid');
          OneSignal.getUserId().then((userId) => {
            _this.api.registerDevice(_this.token, userId, _this.device.browser).subscribe((res: any) => {
              console.table(res);
              window.localStorage.setItem(_this.ONE_SIGNAL_ID, userId);
              // console.log('User ID is', userId);
              _this.oneSignalId = userId;
              _this.listenForNotification();
            }, (err: any) => {
              console.table(err);
            });
          });
        });
      }
    } catch (err) {
      console.table(err);
    }
  }

  checkIfSubscribed() {
      const _this = this;
      console.log('Register For Push');
      OneSignal.push(function() {
        OneSignal.showSlidedownPrompt();
      });
      OneSignal.push(['registerForPushNotifications']);
      OneSignal.push(['getNotificationPermission', function(permission) {
        console.log('Site Notification Permission:', permission);
      }]);
       
      OneSignal.push(function() {
        console.log('OneSignal before check PushNotificationsEnabled');
        OneSignal.isPushNotificationsEnabled(function(isEnabled) {
          if (isEnabled) {
              console.log('Push notifications are enabled!');
              _this.getOneSignalUserID();
          } else {
              console.log('Push notifications are not enabled yet.');
              _this.subscribe();
          }
        }, (error) => {
          console.log('Push permission not granted ');
          console.table(error);
        });
      }, (error) => {
        console.log('Push notification error ');
        console.table(error);
    });
  }

  notificationCount() {
    this.api.notificationCount().subscribe((res: any) => {
      if (res && res.Code === 200 && 'Results' in res && res.Results && 'Badge' in res.Results && res.Results.Badge) {
        this.eventsService.onNotificationCount.emit(res.Results.Badge.toString());
      }
    });
  }
}
